module.exports = "img/photo6.5bce88.jpg";